<template>
  <!-- 月度指标 -->
  <div class="mainWarp">
    <div class="img-title">
      <img src="/iconImg/h_title_bg.png" />
      <span class="DataTitle">监控管理</span>
    </div>
    <div class="main">
      <div class="nameWarp">
        <div v-for="item in dataList" :key="item.id" class="nameItem" @click="checkView(JSON.stringify(item))">
          <img v-if="item.id == selectId" src="~@/assets/myImg/1/icon-selected-camera@2x.png" />
          <img v-else src="~@/assets/myImg/1/icon-default-camera@2x.png" />
          <span :style="{ color: item.id == selectId ? '#FFFFFF' : '#15a9f1', float: 'left', 'margin-left': '10px' }">{{
            item.title
          }}</span>
        </div>
      </div>
      <div class="videoWarp" id="vidio">无视频信号</div>
    </div>
  </div>
</template>

<script>
// import chartResize from '@/mixin/chart-resize'
import EZUIKit from 'ezuikit-js'
import mixinViewModule from '@/mixin/common'
import qs from 'qs'
export default {
  mixins: [mixinViewModule],
  name: 'FaultAlarm',
  components: {},
  data() {
    return {
      url: '',
      queryUrl: '/pipe-network/water_works_monitors/page',
      query: {
        monitorDeviceNo: '',
        pointName: '',
        tenantId: this.$store.state.user.info.tenantId,
      },
      token: '',
      dataList: [],
      selectId: '',
    }
  },
  mounted() {
    this.gettoken()
    this.getList()
  },
  methods: {
    checkView(item) {
      let _item = JSON.parse(item)
      this.selectId = _item.id
      this.url = _item.url
      // console.log(JSON.strinigfy());
      this.$nextTick(() => {
        console.log(this.url)
        this.vidioinit()
      })
    },
    getList() {
      let data = { tenantId: this.query.tenantId, sysConf: '水源监测' }
      this.$http({
        url: this.queryUrl,
        params: data,
      }).then((resolve) => {
        console.log(JSON.stringify(resolve))
        if (parseInt(resolve.data.total) > 0) {
          this.selectId = resolve.data.list[0].id
          this.url = resolve.data.list[0].monitorUrl
          resolve.data.list.map((item) => {
            this.dataList.push({
              title: item.pointName,
              id: item.id,
              url: item.monitorUrl,
            })
          })
          this.$nextTick(() => {
            this.vidioinit()
          })
        }
      })
    },
    gettoken() {
      let url = '/pipe-network/water_works_configurations/page'
      let data = { tenantId: this.query.tenantId, sysConf: '水源监测' }
      this.$http({
        url: url,
        params: data,
      }).then((resolve) => {
        console.log(JSON.stringify(resolve))
        this.token = resolve.data.list[0].token
      })
    },
    vidioinit() {
      if (!this.player) {
        this.player = new EZUIKit.EZUIKitPlayer({
          id: 'vidio', // 视频容器ID
          accessToken: this.token,
          url: this.url,
          width: 371,
          height: 240,
        })
      } else {
        this.player.stop().then(() => {
          this.player.play(this.url)
        })
        return false
      }
      this.player.play()
    },
  },
}
</script>

<style lang="less" scoped>
.mainWarp {
  height: 296px;
  width: 600px;
  background: url(~@/assets/myImg/h_10_jcgl.png) no-repeat;
  background-size: contain;
  position: relative;
  .img-title {
    position: absolute;
    position: relative;
    // top: -18px;
    bottom: 18px;
    text-align: center;
    font-family: MicrosoftYaHeiSemibold;
    font-size: 18px;
    color: #00ebee;
    font-weight: 600;
    line-height: 30px;
    .DataTitle {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
    }
    img {
      //   position: absolute;
      width: 264px;
      height: 40px;
    }
  }
  .main {
    padding: 0 10px;
    position: absolute;
    top: 30px;
    // float: left;
    height: 200px;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    .nameWarp {
      width: 154px;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .nameItem {
        cursor: pointer;
        width: 154px;
        display: flex;
        align-items: center;
        line-height: 50px;
        // justify-content: space-between;
        img {
          width: 24px;
          height: 24px;
        }
        span {
          font-family: MicrosoftYaHeiSemibold;
          font-size: 14px;

          font-weight: 600;
        }
      }
    }
    .videoWarp {
      width: 371px;
      height: 240px;
      background: #050d31;
      color: red;
      font-size: 20px;
      line-height: 240px;
      text-align: center;
      margin-left: -320px;
    }
  }
}
::-webkit-scrollbar {
  width: 0 !important;
}
::-webkit-scrollbar {
  width: 0 !important;
  height: 0;
}
</style>
